import React from 'react';
import PropTypes from 'prop-types';
import AppSafeLink from 'components/AppSafeLink/AppSafeLink';
import ToSentence from '../ToSentence/ToSentence';
import { sortByOrder } from '../../utils/utils';

const Byline = (props) => {
  if (!props || !props.authors) return null;

  function parseToCompLink(authors) {
    let results = [];
    let sortedAuthors = sortByOrder(authors);
    sortedAuthors.forEach((author) =>
      results.push(
        <AppSafeLink href={author.as} className="link link-plain">
          {author.title}
          {author.as.match(/npr/) && ', NPR'}
        </AppSafeLink>
      )
    );
    return results;
  }
  const authors = parseToCompLink(props.authors);

  return (
    <>
      <ToSentence items={authors} />
    </>
  );
};

Byline.propTypes = {
  authors: PropTypes.array,
};

export default Byline;
